import upperFirst from "lodash/upperFirst";
import { FormattedMessage } from "react-intl";

import { Text } from "@/components/atoms/Text";

import type { FsvPaymentScheduleProps } from "./FsvPaymentSchedule.types";
import { FsvPaymentScheduleStep } from "./FsvPaymentScheduleStep";

/**
 * Explains the two payments for an FSV minimum-spend deposit booking.
 */
export const FsvPaymentSchedule = ({
  className,
  currency,
  dueAtVenue,
  dueToday,
  foodDrinkCategoryPhrase,
  headingId,
  minSpend,
  spaceRental,
}: FsvPaymentScheduleProps) => {
  const hasSpaceRentalFee = spaceRental > 0;
  const category = upperFirst(foodDrinkCategoryPhrase);
  const venuePayment = hasSpaceRentalFee ? minSpend : dueAtVenue;

  return (
    <section aria-labelledby={headingId} className={className}>
      <Text
        className="tw-mb-16"
        element="h2"
        id={headingId}
        typeface="headline-1-m"
      >
        <FormattedMessage defaultMessage="Payment schedule" />
      </Text>
      <div className="tw-flex tw-flex-col tw-gap-24">
        <FsvPaymentScheduleStep
          amount={dueToday}
          currency={currency}
          description={
            hasSpaceRentalFee ? (
              <FormattedMessage defaultMessage="Your space rental fee, paid in full to reserve your event." />
            ) : (
              <FormattedMessage defaultMessage="This payment will be credited to your final bill at the venue." />
            )
          }
          number={1}
          title={<FormattedMessage defaultMessage="Due today" />}
        />
        <FsvPaymentScheduleStep
          amount={venuePayment}
          currency={currency}
          description={
            hasSpaceRentalFee ? (
              <FormattedMessage defaultMessage="Paid at the venue during your event." />
            ) : (
              <FormattedMessage defaultMessage="Pay your remaining minimum at the venue during your event." />
            )
          }
          number={2}
          title={
            hasSpaceRentalFee ? (
              <FormattedMessage
                defaultMessage="{category} minimum"
                values={{ category }}
              />
            ) : (
              <FormattedMessage
                defaultMessage="{category} balance"
                values={{ category }}
              />
            )
          }
        />
      </div>
    </section>
  );
};
